import React, { useState, useEffect } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell,
    Select,
    IconButton,
    Tooltip,
    Typography as MuiTypography
} from "@material-ui/core";
import AdminEventService from "./Locality/Service/adminEventService";

import requests from "./Locality/Service/httpService";
import * as Yup from 'yup';
import { Typography } from "../../components/Wrappers/Wrappers";
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: 'auto',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

export default function AdminEvent() {
    const tableHeaders = ['City', 'Event Name', 'Image', 'Category', 'Venue', 'From Date', 'To Date', 'From Time', 'To Time', 'Status', 'Actions'];
    const classes = useStyles();
    const [adminEventList, setAdminEventList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [adminEventToDelete, setAdminEventToDelete] = React.useState(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const [eventImage, setEventImage] = React.useState('');
    const [adminEvent, setAdminEvent] = useState({
        city: '',
        eventName: '',
        eventImage: '',
        fromDate: '',
        toDate: '',
        fromTime: '',
        toTime: '',
        venue: '',
        category: '',
        geoLocation: {
            latitude: '',
            longitude: ''
        },
        specialInstructions: '',
        status: 'active',
    });

    const validationSchema = Yup.object().shape({
        city: Yup.string().required('City is required'),
        eventName: Yup.string().required('Event Name is required'),
        eventImage: Yup.string(),
        fromDate: Yup.date().required('From Date is required'),
        toDate: Yup.date().required('To Date is required').min(Yup.ref('fromDate'), 'To Date must be after From Date'),
        fromTime: Yup.string()
            .required('From Time is required')
            .matches(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i, 'Time must be in 12-hour format (e.g., 9:30 AM)'),
        toTime: Yup.string()
            .required('To Time is required')
            .matches(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i, 'Time must be in 12-hour format (e.g., 5:00 PM)'),
        venue: Yup.string().required('Venue is required'),
        category: Yup.string(),
        specialInstructions: Yup.string(),
        status: Yup.string().required('Status is required'),
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    };

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    };

    useEffect(() => {
        getAdminEventList();
        return () => {
            setAdminEventList([]);
        };
    }, []);

    const getAdminEventList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const profileId = userDetails.role === "admin" ? null : userDetails.profileId;
        
        AdminEventService.getAdminEvent({ profileRegistrationId: profileId }).then((res) => {
            setAdminEventList(res);
        }).catch((err) => {
            console.error(err);
        });
    };

    const handleOpen = () => {
        setAdminEvent({
            city: '',
            eventName: '',
            eventImage: '',
            fromDate: '',
            toDate: '',
            fromTime: '',
            toTime: '',
            venue: '',
            category: '',
            geoLocation: {
                latitude: '',
                longitude: ''
            },
            specialInstructions: '',
            status: 'active',
        });
        setEventImage('');
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setAdminEvent({
            city: '',
            eventName: '',
            eventImage: '',
            fromDate: '',
            toDate: '',
            fromTime: '',
            toTime: '',
            venue: '',
            category: '',
            geoLocation: {
                latitude: '',
                longitude: ''
            },
            specialInstructions: '',
            status: 'active',
        });
        setEventImage('');
    };

    const uploadEventImage = (evt) => {
        const file = evt.target.files[0];
        if (!file) {
            alert("Please select an image to upload");
            return;
        }
        const formData = new FormData();
        formData.append('image', file);
        formData.append('imageName', file.name);
        
        AdminEventService.uploadImage(formData).then((res) => {
            // The uploadRoutes returns the URL directly in res.url
            if (res.url) {
                setEventImage(res.url);
            } else {
                alert("Image uploaded but URL not received");
            }
        }).catch((err) => {
            alert("Error uploading event image: " + (err.response?.data?.message || err.message));
        });
    };

    const removeEventImage = () => {
        setEventImage('');
        // Also clear the existing image from adminEvent state when editing
        if (adminEvent._id) {
            setAdminEvent({
                ...adminEvent,
                eventImage: ''
            });
        }
        // Reset the file input
        const fileInput = document.getElementById('event-image-upload');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    const formatTime = (timeString) => {
        if (!timeString) return 'N/A';
        if (timeString.includes(':')) {
            const timeParts = timeString.split(':');
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1] || '00';
            
            // Handle 24-hour format conversion
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            if (hours === 0) {
                hours = 12; // 12 AM for midnight, 12 PM for noon
            }
            
            return `${hours}:${minutes} ${ampm}`;
        }
        return timeString;
    };

    // Convert 24-hour format to 12-hour format for display
    const convertTo12Hour = (time24) => {
        if (!time24) return '';
        if (time24.includes(':')) {
            const [hours, minutes] = time24.split(':');
            const hour24 = parseInt(hours, 10);
            const ampm = hour24 >= 12 ? 'PM' : 'AM';
            let hour12 = hour24 % 12;
            if (hour12 === 0) hour12 = 12;
            return `${hour12}:${minutes} ${ampm}`;
        }
        return time24;
    };

    // Convert 12-hour format to 24-hour format for storage
    const convertTo24Hour = (time12) => {
        if (!time12) return '';
        const match = time12.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
        if (!match) return time12; // Return as is if format doesn't match
        
        let hours = parseInt(match[1], 10);
        const minutes = match[2];
        const ampm = match[3].toUpperCase();
        
        if (ampm === 'PM' && hours !== 12) {
            hours += 12;
        } else if (ampm === 'AM' && hours === 12) {
            hours = 0;
        }
        
        return `${String(hours).padStart(2, '0')}:${minutes}`;
    };

    // Handle time input change for 12-hour format
    const handleTimeChange = (fieldName, value) => {
        // Allow users to type in 12-hour format directly
        formik.setFieldValue(fieldName, value);
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const editAdminEvent = (eventItem) => {
        const obj = {
            _id: eventItem._id,
            city: eventItem.city || '',
            eventName: eventItem.eventName || '',
            eventImage: eventItem.eventImage || '',
            fromDate: formatDateForInput(eventItem.fromDate),
            toDate: formatDateForInput(eventItem.toDate),
            fromTime: convertTo12Hour(eventItem.fromTime || ''),
            toTime: convertTo12Hour(eventItem.toTime || ''),
            venue: eventItem.venue || '',
            category: eventItem.category || '',
            geoLocation: {
                latitude: eventItem.geoLocation?.latitude || '',
                longitude: eventItem.geoLocation?.longitude || ''
            },
            specialInstructions: eventItem.specialInstructions || '',
            status: eventItem.status || 'active',
        };
        setAdminEvent(obj);
        setEventImage(eventItem.eventImage || '');
        setOpen(true);
    };

    const handleDeleteClick = (eventItem) => {
        setAdminEventToDelete(eventItem);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (adminEventToDelete) {
            AdminEventService.deleteAdminEvent(adminEventToDelete).then((res) => {
                getAdminEventList();
                setDeleteDialogOpen(false);
                setAdminEventToDelete(null);
                alert("Admin Event Deleted Successfully.");
            }).catch((err) => {
                alert("Error deleting admin event: " + (err.response?.data?.message || err.message));
            });
        }
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setAdminEventToDelete(null);
    };

    const formik = useFormik({
        initialValues: adminEvent,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.profileRegistrationId = userDetails.profileId;
            
            // Handle event image
            values.eventImage = eventImage || adminEvent.eventImage || '';
            
            // Convert date strings to Date objects
            if (values.fromDate) {
                values.fromDate = new Date(values.fromDate);
            }
            if (values.toDate) {
                values.toDate = new Date(values.toDate);
            }

            // Convert 12-hour format times to 24-hour format for storage
            if (values.fromTime) {
                values.fromTime = convertTo24Hour(values.fromTime);
            }
            if (values.toTime) {
                values.toTime = convertTo24Hour(values.toTime);
            }

            // Handle geoLocation - convert empty strings to null
            if (values.geoLocation.latitude === '' || values.geoLocation.longitude === '') {
                values.geoLocation = {
                    latitude: values.geoLocation.latitude ? parseFloat(values.geoLocation.latitude) : null,
                    longitude: values.geoLocation.longitude ? parseFloat(values.geoLocation.longitude) : null
                };
            } else {
                values.geoLocation = {
                    latitude: parseFloat(values.geoLocation.latitude),
                    longitude: parseFloat(values.geoLocation.longitude)
                };
            }

            if (adminEvent._id) {
                values._id = adminEvent._id;
                AdminEventService.updateAdminEvent(values).then((res) => {
                    handleClose();
                    getAdminEventList();
                    resetForm();
                    setAdminEvent({
                        city: '',
                        eventName: '',
                        eventImage: '',
                        fromDate: '',
                        toDate: '',
                        fromTime: '',
                        toTime: '',
                        venue: '',
                        category: '',
                        geoLocation: {
                            latitude: '',
                            longitude: ''
                        },
        specialInstructions: '',
        status: 'active',
    });
                    setEventImage('');
                    alert("Admin Event Updated Successfully.");
                }).catch((err) => {
                    alert("Error updating admin event: " + (err.response?.data?.message || err.message));
                });
            } else {
                AdminEventService.createAdminEvent(values).then((res) => {
                    getAdminEventList();
                    resetForm();
                    handleClose();
                    setAdminEvent({
                        city: '',
                        eventName: '',
                        eventImage: '',
                        fromDate: '',
                        toDate: '',
                        fromTime: '',
                        toTime: '',
                        venue: '',
                        category: '',
                        geoLocation: {
                            latitude: '',
                            longitude: ''
                        },
        specialInstructions: '',
        status: 'active',
    });
                    setEventImage('');
                    alert("Admin Event Added Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error adding admin event");
                });
            }
        },
    });

    return (
        <>
            <PageTitle title="Admin Events" button={<Button
                variant="contained" onClick={handleOpen}
                size="medium"
                color="secondary" style={{ backgroundColor: '#ff6b81' }}> Add Admin Event
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <Table className="mb-0">
                            <TableHead>
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {adminEventList.slice(pg * rpg, pg * rpg + rpg).map((eventItem) => (
                                    <TableRow key={eventItem._id}>
                                        <TableCell className="pl-3 fw-normal">{eventItem.city}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{eventItem.eventName}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {eventItem.eventImage ? (
                                                <img 
                                                    src={eventItem.eventImage} 
                                                    alt={eventItem.eventName || 'Event'} 
                                                    style={{ 
                                                        width: '60px', 
                                                        height: '60px', 
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ddd',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => window.open(eventItem.eventImage, '_blank')}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                    }}
                                                />
                                            ) : (
                                                <span style={{ color: '#999', fontSize: '12px' }}>No Image</span>
                                            )}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">{eventItem.category || '-'}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{eventItem.venue}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatDate(eventItem.fromDate)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatDate(eventItem.toDate)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatTime(eventItem.fromTime)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{formatTime(eventItem.toTime)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            <span style={{
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                textTransform: 'capitalize',
                                                backgroundColor: eventItem.status === 'active' ? '#4caf50' : '#f44336',
                                                color: 'white'
                                            }}>
                                                {eventItem.status}
                                            </span>
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            <Tooltip title="Edit Admin Event">
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => editAdminEvent(eventItem)}
                                                    style={{ color: '#1976d2' }}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete Admin Event">
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => handleDeleteClick(eventItem)}
                                                    style={{ color: '#d32f2f' }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            count={adminEventList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                <DialogTitle>{adminEvent._id ? 'Edit Admin Event' : 'Add Admin Event'}</DialogTitle>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="city"
                                    name="city"
                                    label="City"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.city}
                                    error={formik.touched.city && Boolean(formik.errors.city)}
                                    helperText={formik.touched.city && formik.errors.city}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="eventName"
                                    name="eventName"
                                    label="Event Name"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.eventName}
                                    error={formik.touched.eventName && Boolean(formik.errors.eventName)}
                                    helperText={formik.touched.eventName && formik.errors.eventName}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <MuiTypography variant="body2" style={{ marginBottom: 8, fontWeight: 'bold' }}>
                                    Event Image
                                </MuiTypography>
                                <input
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    id="event-image-upload"
                                    type="file"
                                    onChange={uploadEventImage}
                                />
                                <label htmlFor="event-image-upload">
                                    <Button 
                                        variant="outlined" 
                                        component="span" 
                                        fullWidth 
                                        style={{ marginBottom: 8 }}
                                    >
                                        Upload Event Image
                                    </Button>
                                </label>
                                
                                {/* Show uploaded image with remove button */}
                                {eventImage && (
                                    <div style={{ 
                                        marginTop: 8, 
                                        position: 'relative',
                                        display: 'inline-block',
                                        width: '100%'
                                    }}>
                                        <div style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                            width: '100%',
                                            maxWidth: '400px'
                                        }}>
                                            <img 
                                                src={eventImage} 
                                                alt="Event preview" 
                                                style={{ 
                                                    width: '100%',
                                                    maxHeight: '300px', 
                                                    objectFit: 'contain',
                                                    border: '2px solid #ddd',
                                                    borderRadius: '8px',
                                                    padding: '8px',
                                                    backgroundColor: '#f5f5f5'
                                                }} 
                                            />
                                            <Tooltip title="Remove Image">
                                                <IconButton
                                                    onClick={removeEventImage}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        right: 8,
                                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                        color: '#d32f2f',
                                                        padding: '4px',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                    }}
                                                    size="small"
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        <MuiTypography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 4 }}>
                                            Image uploaded successfully. Click the X button to remove.
                                        </MuiTypography>
                                    </div>
                                )}
                                
                                {/* Show existing image when editing (if no new image uploaded) */}
                                {!eventImage && adminEvent.eventImage && (
                                    <div style={{ 
                                        marginTop: 8, 
                                        position: 'relative',
                                        display: 'inline-block',
                                        width: '100%'
                                    }}>
                                        <MuiTypography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: 4 }}>
                                            Current Image:
                                        </MuiTypography>
                                        <div style={{
                                            position: 'relative',
                                            display: 'inline-block',
                                            width: '100%',
                                            maxWidth: '400px'
                                        }}>
                                            <img 
                                                src={adminEvent.eventImage} 
                                                alt="Current event" 
                                                style={{ 
                                                    width: '100%',
                                                    maxHeight: '300px', 
                                                    objectFit: 'contain',
                                                    border: '2px solid #ddd',
                                                    borderRadius: '8px',
                                                    padding: '8px',
                                                    backgroundColor: '#f5f5f5'
                                                }} 
                                            />
                                            <Tooltip title="Remove Image">
                                                <IconButton
                                                    onClick={removeEventImage}
                                                    style={{
                                                        position: 'absolute',
                                                        top: 8,
                                                        right: 8,
                                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                        color: '#d32f2f',
                                                        padding: '4px',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                    }}
                                                    size="small"
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="fromDate"
                                    name="fromDate"
                                    label="From Date"
                                    type="date"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.fromDate}
                                    error={formik.touched.fromDate && Boolean(formik.errors.fromDate)}
                                    helperText={formik.touched.fromDate && formik.errors.fromDate}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="toDate"
                                    name="toDate"
                                    label="To Date"
                                    type="date"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.toDate}
                                    error={formik.touched.toDate && Boolean(formik.errors.toDate)}
                                    helperText={formik.touched.toDate && formik.errors.toDate}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="fromTime"
                                    name="fromTime"
                                    label="From Time (e.g., 9:30 AM)"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={(e) => handleTimeChange('fromTime', e.target.value)}
                                    value={formik.values.fromTime}
                                    error={formik.touched.fromTime && Boolean(formik.errors.fromTime)}
                                    helperText={formik.touched.fromTime ? formik.errors.fromTime : "Format: H:MM AM/PM (e.g., 9:30 AM, 2:45 PM)"}
                                    placeholder="9:30 AM"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="toTime"
                                    name="toTime"
                                    label="To Time (e.g., 5:00 PM)"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={(e) => handleTimeChange('toTime', e.target.value)}
                                    value={formik.values.toTime}
                                    error={formik.touched.toTime && Boolean(formik.errors.toTime)}
                                    helperText={formik.touched.toTime ? formik.errors.toTime : "Format: H:MM AM/PM (e.g., 9:30 AM, 2:45 PM)"}
                                    placeholder="5:00 PM"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="category"
                                    name="category"
                                    label="Category"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.category}
                                    error={formik.touched.category && Boolean(formik.errors.category)}
                                    helperText={formik.touched.category && formik.errors.category}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="venue"
                                    name="venue"
                                    label="Venue"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.venue}
                                    error={formik.touched.venue && Boolean(formik.errors.venue)}
                                    helperText={formik.touched.venue && formik.errors.venue}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="geoLocation.latitude"
                                    name="geoLocation.latitude"
                                    label="Latitude"
                                    type="number"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={(e) => formik.setFieldValue('geoLocation.latitude', e.target.value)}
                                    value={formik.values.geoLocation.latitude}
                                    error={formik.touched.geoLocation?.latitude && Boolean(formik.errors.geoLocation?.latitude)}
                                    helperText={formik.touched.geoLocation?.latitude && formik.errors.geoLocation?.latitude}
                                    inputProps={{
                                        step: "any"
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id="geoLocation.longitude"
                                    name="geoLocation.longitude"
                                    label="Longitude"
                                    type="number"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={(e) => formik.setFieldValue('geoLocation.longitude', e.target.value)}
                                    value={formik.values.geoLocation.longitude}
                                    error={formik.touched.geoLocation?.longitude && Boolean(formik.errors.geoLocation?.longitude)}
                                    helperText={formik.touched.geoLocation?.longitude && formik.errors.geoLocation?.longitude}
                                    inputProps={{
                                        step: "any"
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="specialInstructions"
                                    name="specialInstructions"
                                    label="Special Instructions"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    multiline
                                    rows={4}
                                    onChange={formik.handleChange}
                                    value={formik.values.specialInstructions}
                                    error={formik.touched.specialInstructions && Boolean(formik.errors.specialInstructions)}
                                    helperText={formik.touched.specialInstructions && formik.errors.specialInstructions}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="status-select-label">Status</InputLabel>
                                    <Select
                                        labelId="status-select-label"
                                        id="status"
                                        name="status"
                                        value={formik.values.status}
                                        onChange={formik.handleChange}
                                        label="Status"
                                    >
                                        <MenuItem value="active">Active</MenuItem>
                                        <MenuItem value="inactive">Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit" color="primary" variant="contained">
                            {adminEvent._id ? 'Update' : 'Add'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Delete Admin Event</DialogTitle>
                <DialogContent>
                    <MuiTypography>
                        Are you sure you want to delete this admin event? This action cannot be undone.
                    </MuiTypography>
                    {adminEventToDelete && (
                        <MuiTypography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                            Event: {adminEventToDelete.eventName || 'N/A'}<br />
                            City: {adminEventToDelete.city || 'N/A'}<br />
                            Venue: {adminEventToDelete.venue || 'N/A'}
                        </MuiTypography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="secondary" variant="contained" style={{ backgroundColor: '#d32f2f' }}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

